import gql from "graphql-tag";
import { siteSubscriptionFragment } from './siteSubscriptionFragments'
import { companyFragment } from '@/graphql/company/companyFragments'

export const updateSiteSubscription = gql`
    mutation updateSiteSubscription(
        $name: String
        # $type: SiteSubscriptionTypes
        # $owner: ID
        $company_id: ID
    ){
        updateSiteSubscription(
            input: {
                name: $name
                # type: $type
                company: {
                    connect : $company_id
                }
            }
        ){
            ...siteSubscriptionFragment
            company{
                ...companyFragment
            }
        }
    }
    ${siteSubscriptionFragment}
    ${companyFragment}
`;